import { Laydown } from './types';

const INDICATOR_SIZE = 0.08;

const X_TRANSLATION = {
  center: '-50%',
  left: '0%',
  right: '-100%',
};

const Y_TRANSLATION = {
  center: '-50%',
  top: '0%',
  bottom: '-100%',
};

const JUSTIFY_CONTENT = {
  center: 'center',
  top: 'flex-start',
  bottom: 'flex-end',
};

export const transformCss = (laydown: Laydown) => {
  const xValue = X_TRANSLATION[laydown.xAnchor];
  const yValue = Y_TRANSLATION[laydown.yAnchor];

  return `translate(${xValue}, ${yValue})`;
};

export const justifyContentCss = (laydown: Laydown) => {
  return JUSTIFY_CONTENT[laydown.yAnchor];
};

export const toPercent = (float: number) => {
  return `${Math.round(float * 100)}%`;
};

export const topCss = (laydown: Laydown, hasLabel?: boolean) => {
  let topValue = laydown.y;

  if (hasLabel && laydown.yAnchor === 'top') {
    topValue -= INDICATOR_SIZE;
  } else if (hasLabel && laydown.yAnchor === 'center') {
    topValue -= 0.5 * INDICATOR_SIZE;
  }

  return toPercent(topValue);
};
